import axios from 'axios';

const api = axios.create({
    baseURL: 'https://api.e-assessoriafinanceira.com.br/'
});

export default api;